import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShieldMoonIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shield_moon"}/>
}
